export default __webpack_public_path__ + "static/media/19_TopLeftSquares_Alpha.9bc631c3.mp4";